import { render, staticRenderFns } from "./SupplierManageMaterialList.vue?vue&type=template&id=06aef951&scoped=true&"
import script from "./SupplierManageMaterialList.vue?vue&type=script&lang=js&"
export * from "./SupplierManageMaterialList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06aef951",
  null
  
)

export default component.exports